import React from 'react';

import { JuridictionViolationDtoFormFieldEnum } from 'lib_api/lib/api/gen';

import BaseSelectJuridiction from 'components/BaseForm/Select/juridiction/BaseSelectJuridiction';
import BaseSelectTypeJuridiction from 'components/BaseForm/Select/juridiction/BaseSelectTypeJuridiction';
import { FormInputProps } from 'components/BaseForm/types';

import BaseModalEdition from '../../Modals/ModalEdition/ModalEdition';
import { JuridictionFormValue } from '../types';

interface ModalEditionProps {
  close: () => void;
  visible: boolean;
  initials: JuridictionFormValue;
  title: string;
  submit: (values: JuridictionFormValue) => void;
  isSubmitting: boolean;
  validate: (
    field: JuridictionViolationDtoFormFieldEnum,
    values: JuridictionFormValue,
  ) => Promise<void>;
}

function ModalEdition({ ...props }: ModalEditionProps): React.ReactElement {
  const inputs: Array<
    FormInputProps<JuridictionFormValue, JuridictionViolationDtoFormFieldEnum>
  > = [
    {
      name: 'libelle',
      label: 'Libellé',
      field: JuridictionViolationDtoFormFieldEnum.LIBELLE,
      required: true,
    },
    {
      name: 'type',
      label: 'Type',
      field: JuridictionViolationDtoFormFieldEnum.TYPE,
      required: true,
      render: () => <BaseSelectTypeJuridiction />,
    },
    {
      name: 'numero',
      label: 'Numéro',
      field: JuridictionViolationDtoFormFieldEnum.NUMERO,
      required: true,
    },
    {
      name: 'origineElement',
      label: 'Origine',
      field: JuridictionViolationDtoFormFieldEnum.ORIGINE_ELEMENT,
      required: true,
    },
    {
      name: 'codePostal',
      label: 'Code postal',
      field: JuridictionViolationDtoFormFieldEnum.CODE_POSTAL,
      required: false,
    },
    {
      name: 'juridictionParente',
      label: 'Juridiction parente',
      field: JuridictionViolationDtoFormFieldEnum.JURIDICTION_PARENTE,
      required: false,
      render: () => <BaseSelectJuridiction />,
    },
  ];

  return <BaseModalEdition {...props} inputs={inputs} />;
}

export default ModalEdition;
